var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerComponent"},[_c('img',{staticClass:"logo d-none d-md-block",attrs:{"src":require("vue_root/assets/images/logo-white.png"),"alt":"herculift-logo"}}),_vm._v(" "),_c('div',{staticClass:"copyrightNotice m-auto text-center"},[_vm._v("\n        Copyright © 2020 Herc-U-Lift All rights reserved.\n    ")])])
}]

export { render, staticRenderFns }